import { padding } from "../../../theme";

const infoRowWidth = "100%";

export const MachineStyle = {
  infoSection: {
    paddingBottom: padding * 2,
    maxWidth: infoRowWidth,
    minWidth: 350,
    flex: 2,
    flexDirection: "row",
  },
  paddingTop: {
    paddingTop: padding * 2,
  },
  infoRow: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    verticalAlign: 'middle',
    marginTop: "16px", // Motsvarar ofta mt: 2 i MUI
    width: "100%",
    
  }
};
